import { useEffect, useRef, type ReactNode } from 'react'
import { XCloseIcon } from '@/shared/ui/icons/XCloseIcon'

export function ModalPc({
  title,
  label,
  onClose,
  footer,
  children,
}: {
  title: string
  label?: string
  onClose: () => void
  footer?: ReactNode
  children: ReactNode
}) {
  const ref = useRef<HTMLDialogElement>(null)

  useEffect(() => {
    const el = ref.current
    if (el === null || el.open) return
    el.showModal()
  }, [])

  useEffect(() => {
    const prev = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = prev
    }
  }, [])

  return (
    <dialog
      ref={ref}
      aria-label={label}
      aria-labelledby={label === undefined ? 'modal-pc-title' : undefined}
      onClose={onClose}
      onClick={(e) => {
        if (e.target === ref.current) onClose()
      }}
      className="m-auto max-h-[calc(100vh-64px)] max-w-[calc(100vw-32px)] overflow-hidden rounded-3xl border-0 bg-white-50 p-0 text-black-600 backdrop:bg-black-800/30 backdrop:backdrop-blur-[2px]"
    >
      <div className="flex h-[697px] max-h-full w-[661px] max-w-full flex-col gap-[18px] px-7 py-5">
        <div className="flex shrink-0 items-center justify-center gap-3">
          <h2
            id="modal-pc-title"
            className="m-0 min-w-0 flex-1 text-headline-xs font-semibold tracking-[-0.1px] text-black-800"
          >
            {title}
          </h2>
          <button
            type="button"
            className="ui-pressable inline-flex h-10 w-10 shrink-0 cursor-pointer items-center justify-center rounded-lg border-0 bg-none p-0 text-black-600"
            aria-label="닫기"
            onClick={onClose}
          >
            <XCloseIcon />
          </button>
        </div>

        <div className="flex min-h-0 flex-1 flex-col">{children}</div>

        {footer !== undefined && (
          <div className="flex shrink-0 items-center gap-2 pt-[7px]">{footer}</div>
        )}
      </div>
    </dialog>
  )
}
